var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        {
          staticClass: "msg-notification-card",
          class: { "is-minimized": _vm.isMinimized },
          style: {
            left: _vm.position.left + "px",
            top: _vm.position.top + "px",
          },
        },
        [
          _c("div", { staticClass: "window-controls" }, [
            _c(
              "button",
              {
                staticClass: "control-btn mini-btn",
                attrs: { title: _vm.isMinimized ? "还原" : "最小化" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.toggleMinimize.apply(null, arguments)
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.isMinimized ? "▢" : "－") + " ")]
            ),
            _c(
              "button",
              {
                staticClass: "control-btn close-btn",
                attrs: { title: "关闭" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.handleClose.apply(null, arguments)
                  },
                },
              },
              [_vm._v(" ✕ ")]
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "card-header",
              on: {
                mousedown: _vm.startDrag,
                touchstart: _vm.startDrag,
                dblclick: _vm.toggleMinimize,
              },
            },
            [
              _c("div", { staticClass: "header-left-content" }, [
                _vm.isMinimized
                  ? _c("span", { staticClass: "mini-title" }, [
                      _vm._v(
                        " 合开中... (" +
                          _vm._s(_vm.displayCurrent) +
                          " / " +
                          _vm._s(_vm.displayTotal) +
                          ") "
                      ),
                    ])
                  : _c("div", { staticClass: "header-full-content" }, [
                      _c("div", { staticClass: "icon-container" }, [
                        _c("div", { staticClass: "glowing-box" }, [
                          _vm.lastCasePicture
                            ? _c("img", {
                                attrs: {
                                  src: _vm.lastCasePicture,
                                  alt: "case-img",
                                },
                              })
                            : _vm._e(),
                        ]),
                      ]),
                      _c("div", { staticClass: "progress-container" }, [
                        _c("div", { staticClass: "status-text" }, [
                          _c("span", [_vm._v("合开状态:")]),
                          _c("span", { staticClass: "status-value" }, [
                            _vm._v(
                              _vm._s(_vm.displayCurrent) +
                                " / " +
                                _vm._s(_vm.displayTotal)
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "progress-bar-bg" }, [
                          _c("div", {
                            staticClass: "progress-bar-fill",
                            style: { width: _vm.progressPercentage + "%" },
                          }),
                        ]),
                      ]),
                    ]),
              ]),
            ]
          ),
          _c("div", { staticClass: "window-body-wrapper" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "countdown-timer" }, [
                _vm._v(_vm._s(_vm.formattedTime)),
              ]),
            ]),
            _c("div", { staticClass: "card-footer" }, [
              _c("div", { staticClass: "footer-left" }, [
                _c("p", { staticClass: "footer-hint" }, [
                  _vm._v("有人创建了合开局，速来开！"),
                ]),
                _c(
                  "label",
                  {
                    staticClass: "no-remind-label",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.dontRemindToday,
                          expression: "dontRemindToday",
                        },
                      ],
                      staticClass: "no-remind-checkbox",
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.dontRemindToday)
                          ? _vm._i(_vm.dontRemindToday, null) > -1
                          : _vm.dontRemindToday,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.dontRemindToday,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.dontRemindToday = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.dontRemindToday = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.dontRemindToday = $$c
                          }
                        },
                      },
                    }),
                    _c("span", [_vm._v("今日不再提醒")]),
                  ]
                ),
              ]),
              _c(
                "button",
                { staticClass: "join-btn", on: { click: _vm.handleJoin } },
                [_vm._v("立即加入")]
              ),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }